// quick-view-modal-carousel-fixed.js
document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  // ---------- Helpers ----------
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) =>
    Array.prototype.slice.call(root.querySelectorAll(selector));

  const carouselState = {
    currentColorIndex: 0,
    colorImages: {},
    currentSlideIndex: 0,
    totalSlides: 0,
    isLoadingImages: false
  };

  const productCache = {};
  let currentQuickViewProduct = null;

  // Per-product option meta
  let productOptionMeta = [];
  let productColorMeta = null;
  let productSizeMeta = null;

  // Preload image cache
  const imagePreloadCache = new Map();

  // ---------- Image Preloading ----------
  function preloadImages(imageUrls) {
    imageUrls.forEach(url => {
      if (!imagePreloadCache.has(url)) {
        const img = new Image();
        img.src = url;
        img.loading = 'eager';
        imagePreloadCache.set(url, img);
      }
    });
  }

  // ---------- Color helpers (for swatches) ----------
  function mapColorNameToHex(name) {
    const normalize = (str) =>
      String(str || '')
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-');

    const key = normalize(name);

    // 1) Theme-provided map
    if (window.themeColorMap && window.themeColorMap[key]) {
      return window.themeColorMap[key];
    }

    // 2) Fallback for common color names
    const fallback = {
      black: '#000000',
      white: '#ffffff',
      clear: '#f5f5f5',
      transparent: '#f5f5f5',
      grey: '#c4c4c4',
      gray: '#c4c4c4',
      silver: '#d9d9d9',
      graphite: '#3c3c43',
      blue: '#007aff',
      navy: '#001f3f',
      green: '#34c759',
      red: '#ff3b30',
      orange: '#ff7a00',
      yellow: '#ffd60a',
      purple: '#5e5ce6',
      pink: '#ff2d55'
    };

    return fallback[key] || '#cccccc';
  }

  function getAutoSwatchForColor(colorName) {
    return mapColorNameToHex(colorName);
  }

  // ---------- Modal Creation ----------
  if (!$('#quickViewModal')) {
    createModal();
  }

  function createModal() {
    const modalHTML = `
      <div id="quickViewModal" class="quick-view-modal" style="display:none;position:fixed;top:0;left:0;width:100%;height:100%;z-index:9999;align-items:center;justify-content:center;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;">
        <div class="qv-overlay" style="position:absolute;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.85);"></div>

        <div class="qv-container" style="position:relative;background:#FFFFFF;max-width:1024px;width:100%;max-height:100vh;overflow-y:auto;box-shadow:0 20px 60px rgba(0,0,0,0.3);">
          <button class="qv-close" style="position:absolute;top:15px;right:24px;font-family: var(--font-subtitle-family);font-size:14px;width:48px;height:48px;color:#7F7F7F;background:rgba(255,255,255,0);border:none;cursor:pointer;display:flex;align-items:center;justify-content:center;z-index:20;">
            CLOSE
          </button>

          <div class="qv-content" style="display:flex;height:100%;">
            <!-- Left Column - Image Carousel -->
            <div class="qv-image-column" style="flex:0.6;background:#F8F8F8;position:relative;overflow:hidden;">
              <div class="qv-carousel-container" style="width:100%;height:100%;position:relative;">  
                <button class="qv-carousel-arrow qv-carousel-prev" aria-label="Previous image">
                  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" class="icon icon-arrow-big" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.9455 23.707L34.5313 23.707L34.5313 25.707L16.9455 25.707L23.2384 31.9998L21.8241 33.4141L13.8241 25.4141L13.117 24.707L13.8241 23.9998L21.8241 15.9999L23.2384 17.4141L16.9455 23.707Z" fill="currentColor"></path>
                  </svg>
                </button>

                <button class="qv-carousel-arrow qv-carousel-next" aria-label="Next image">
                  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" class="icon icon-arrow-big" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M31.5858 25.7071H14V23.7071H31.5858L25.2929 17.4142L26.7071 16L34.7071 24L35.4142 24.7071L34.7071 25.4142L26.7071 33.4142L25.2929 32L31.5858 25.7071Z" fill="currentColor"></path>
                  </svg>
                </button>

                <div class="qv-carousel-track" style="display:flex;height:100%;width:100%;position:relative;">
                </div>

                <div class="qv-carousel-dots" style="position:absolute;bottom:40px;left:0;right:0;display:flex;justify-content:center;gap:12px;z-index:15;">
                </div>
              </div>

            </div>

            <!-- Right Column - Product Info -->
            <div class="qv-info-column" style="flex:0.4;padding:60px 40px;display:flex;flex-direction:column;overflow-y:auto;">
              <h1 class="qv-title" style="font-size:32px;font-weight:500;color:#000;margin-bottom:5px;line-height:1.1;">
                PRODUCT
              </h1>

              <div class="qv-product-type" style="font-family: var(--font-body-family);font-style: var(--font-body-style);font-weight: var(--font-body-weight);font-size: 12pt;color:#000;letter-spacing:0.5px;margin-bottom:3px;">
                Product Type
              </div>

              <div class="qv-price" style="font-family: var(--font-price-card-family);font-style: var(--font-prcie-card-style);font-size: 12pt;color: rgb(var(--color-foreground-title));margin-bottom:24px;">
                $0.00
              </div>

              <div class="qv-separator" style="height:1px;background:#000;width:90%;margin-bottom:24px;"></div>

              <!-- SIZE Section -->
              <div class="qv-section qv-section-size" style="margin-bottom:20px;display:none;">
                <h3 class="qv-section-title" style="font-size:12pt;font-weight:500;color:#666;margin:0 0 12px 0;letter-spacing:1.5px;">
                  Size:
                </h3>
                <div class="qv-sizes" style="display:flex;gap:8px;flex-wrap:wrap;">
                  <!-- Sizes will be added dynamically -->
                </div>
              </div>

              <!-- Colour Section -->
              <div class="qv-section qv-section-color" style="margin-bottom:20px;display:none;">
                <h3 class="qv-section-title" style="font-family: var(--font-subtitle-family);font-size:12pt;font-weight:400;color:#666;margin:0 0 12px 0;letter-spacing:1.5px;">
                  Colour:
                </h3>
                <div class="qv-colors" style="display:flex;gap:10px;flex-wrap:wrap;">
                  <!-- Colors will be dynamically added -->
                </div>
              </div>

              <!-- Quantity Section -->
              <div class="qv-section" style="margin-bottom:40px;">
                <div class="qv-quantity" style="display:flex;align-items:center;border:0;">
                  <button class="qv-minus" style="border:0;width:44px;height:44px;background:#F5F5F5;font-size:20px;font-weight:600;color:#000;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:all 0.2s;line-height:1;">
                    -
                  </button>
                  <input type="number" class="qv-qty-input" value="1" min="1" style="border:0;outline:0;box-shadow:0 0 0 rgb(var(--color-foreground));width:100px;height:44px;background:#F5F5F5;text-align:center;font-size:16px;font-weight:600;color:#000;padding:0;">
                  <button class="qv-plus" style="border:0;width:44px;height:44px;background:#F5F5F5;font-size:20px;font-weight:600;color:#000;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:all 0.2s;line-height:1;">
                    +
                  </button>
                </div>
              </div>

              <!-- Payment Options Section -->
              <div class="qv-payment-section" style="margin-top:auto;">
                <button class="qv-add-to-cart" style="width:100%;height:40px;background:#000;margin-bottom:10px;color:white;border:none;font-family: var(--font-button-family);font-weight: var(--font-button-weight);font-style: var(--font-button-style);text-transform: var(--font-button-text-transform);letter-spacing: calc(var(--font-button-letter-spacing)*.1);font-size: 12pt;line-height: 1.2;cursor: pointer;transition:all 0.2s;">
                  ADD TO CART
                </button>

                <button class="qv-buy-with-pay" style="width:100%;height:40px;background:#000;margin-bottom:10px;color:white;border:none;font-family: var(--font-button-family);font-weight: var(--font-button-weight);font-style: var(--font-button-style);text-transform: var(--font-button-text-transform);letter-spacing: calc(var(--font-button-letter-spacing)*.1);font-size: 12pt;line-height: 1.2;cursor: pointer;transition:all 0.2s;">
                  BUY WITH
                  <svg xmlns="http://www.w3.org/2000/svg" width="45" viewBox="0 0 41 17" style="margin-bottom: -5px;">
                    <path d="M19.526 2.635v4.083h2.518q.9 0 1.488-.605.605-.604.605-1.437 0-.816-.605-1.422-.588-.62-1.488-.62h-2.518zm0 5.52v4.736h-1.504V1.198h3.99q1.519 0 2.582 1.012 1.08 1.013 1.08 2.466 0 1.487-1.08 2.482-1.046.997-2.583.996zm7.668 2.287q0 .587.499.98.498.39 1.168.391.949 0 1.692-.701.745-.703.744-1.65-.704-.555-1.962-.555-.916 0-1.528.442-.613.44-.613 1.093m1.946-5.815q1.668 0 2.633.89.964.891.964 2.442v4.932h-1.439v-1.11h-.065q-.933 1.372-2.486 1.372-1.323 0-2.215-.784t-.891-1.96q0-1.242.94-1.976c.94-.734 1.463-.735 2.51-.735q1.34 0 2.206.49v-.344q0-.784-.621-1.33a2.13 2.13 0 0 0-1.455-.547q-1.26 0-1.995 1.062l-1.324-.834q1.095-1.568 3.238-1.568m11.853.262-5.02 11.53H34.42l1.864-4.034-3.302-7.496h1.635l2.387 5.749h.032l2.322-5.75z" style="fill:#fff"></path>
                    <path d="M13.448 7.134q-.001-.71-.116-1.366H6.988v2.588h3.634a3.1 3.1 0 0 1-1.344 2.042v1.68h2.169c1.27-1.17 2.001-2.9 2.001-4.944" style="fill:#4285f4"></path>
                    <path d="M6.988 13.7c1.816 0 3.344-.595 4.459-1.621l-2.169-1.681c-.603.406-1.38.643-2.29.643-1.754 0-3.244-1.182-3.776-2.774H.978v1.731a6.73 6.73 0 0 0 6.01 3.703" style="fill:#34a853"></path>
                    <path d="M3.212 8.267a4.03 4.03 0 0 1 0-2.572V3.964H.978A6.7 6.7 0 0 0 .261 6.98c0 1.085.26 2.11.717 3.017z" style="fill:#fbbc05"></path>
                    <path d="M6.988 2.921c.992 0 1.88.34 2.58 1.008v.001l1.92-1.918C10.324.928 8.804.262 6.989.262a6.73 6.73 0 0 0-6.01 3.702l2.234 1.731c.532-1.592 2.022-2.774 3.776-2.774" style="fill:#ea4335"></path>
                  </svg>
                </button>

                <button class="qv-more-options" style="width:100%;text-decoration:underline;border:0;background:transparent;color:#666;font-family: var(--font-button-family);font-size:16px;font-weight:500;letter-spacing: calc(var(--font-button-letter-spacing)*.1);cursor:pointer;transition:all 0.2s;">
                  MORE PAYMENT OPTIONS
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>
        .quick-view-trigger:visited, .quick-view-trigger span:visited {
          background: transparent !important;
          text-decoration: antiquewhite !important;
        }
        .quick-view-trigger:focus-visible, .quick-view-trigger span:focus-visible {
          background: transparent !important;
          outline: 0 !important;
          box-shadow: 0 0 0 !important;
        }
        
        /* FADE EFFECT CAROUSEL */
        .qv-carousel-container {
          aspect-ratio: 1 / 1;
          position: relative;
          overflow: hidden;
        }
        
        .qv-carousel-track {
          display: flex;
          height: 100%;
          width: 100%;
          position: relative;
        }
        
        .qv-carousel-slide {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 60px;
          opacity: 0;
          transition: opacity 0.5s ease-in-out;
          pointer-events: none;
          z-index: 1;
        }
        
        .qv-carousel-slide.active {
          opacity: 1;
          pointer-events: auto;
          z-index: 2;
          position: relative;
        }
        
        .qv-carousel-slide img {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
          display: block;
          margin: 0 auto;
        }      
        
        /* =========================================
          DESKTOP HOVER ARROWS
        ========================================= */
        .qv-carousel-arrow {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 52px;
          height: 48px;
          background: transparent;
          border: none;
          font-size: 28px;
          font-weight: 400;
          color: #000;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 100;
          opacity: 0;
          pointer-events: none;
          transition: opacity 0.2s ease;
        }
        
        .qv-carousel-prev {
          left: 15px;
        }
        
        .qv-carousel-next {
          right: 15px;
        }
        
        .qv-carousel-arrow svg {                 
          padding: 4px;          
        }
        
        .qv-carousel-dot {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: #C7C7C7;
          cursor: pointer;
          padding: 0;
          border: 0;
          transition: all 0.3s;
          z-index: 30;
          position: relative;
        }
        
        .qv-carousel-dot:hover,
        .qv-carousel-dot.active {
          background: black;
        }
        
        .qv-color-option,
        .qv-size-option {
          position: relative;
          cursor: pointer;
        }
        
        .qv-add-to-cart:hover,
        .qv-buy-with-pay:hover {
          background: #333 !important;
          transform: translateY(-2px);
        }
        
        .qv-more-options:hover {
          color: #000 !important;
          transform: translateY(-2px);
        }
        
        input[type="number"]::-webkit-outer-spin-button,
        input[type="number"]::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
        
        input[type="number"] {
          -moz-appearance: textfield;
        }
        
        .qv-qty-input:focus {
          outline: none;
          border-color: #000 !important;
        }

        .qv-loading-spinner {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          border: 3px solid rgba(0,0,0,0.15);
          border-top-color: #000;
          animation: qvSpin 0.6s linear infinite;
        }
        
        .qv-loading-text {
          margin-top: 12px;
          font-size: 13px;
          letter-spacing: 0.08em;          
          color: #777;
        }

        /* Show arrows on hover (desktop only) */
        @media (hover: hover) and (pointer: fine) {
          .qv-carousel-container:hover .qv-carousel-arrow {
            opacity: 1;
            pointer-events: auto;
          }          
        }

        @keyframes qvSlideUp {
          from { transform: translateY(100%); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
        
        .quick-view-modal.show .qv-container {
          animation: qvSlideUp 0.35s ease-out forwards;
        }
        
        @keyframes qvSlideDown {
          from { transform: translateY(0); opacity: 1; }
          to { transform: translateY(100%); opacity: 0; }
        }
        
        .quick-view-modal.hide .qv-container {
          animation: qvSlideDown 0.3s ease-in forwards;
        }
        
        @keyframes qvSpin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        @media (max-width: 768px) {
          .qv-carousel-container {
            aspect-ratio: auto;
          }
          
          .qv-container {
            height: 100vh;
          }
          
          .qv-carousel-slide {
            padding: 20px !important;
          }
          
          .qv-carousel-slide img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
          
          .qv-content {
            flex-direction: column !important;
            height: auto !important;
          }
          
          .qv-title {
            margin-bottom: 0 !important;
            font-size: 21px !important;
          }
          
          .qv-product-type {
            font-size: 10pt !important;
            margin-bottom: 5px !important;
          }
          
          .qv-price {
            font-size: 10pt !important;
          }
          
          .qv-separator {
            display: none;
          }
          
          .qv-image-column {
            width: 100% !important;
            height: 360px !important;
            flex: none !important;
          }
          
          .qv-info-column {
            width: 100% !important;
            padding: 30px 20px !important;
            flex: none !important;
            max-height: unset !important;
          }
          
          .qv-carousel-arrow {
            display: none !important;
          }
          
          .quick-view-trigger,
          .qv-close,
          .qv-carousel-dot,
          .qv-color-option,
          .qv-size-option,
          .qv-minus,
          .qv-plus,
          .qv-add-to-cart,
          .qv-buy-with-pay,
          .qv-more-options {
            -webkit-tap-highlight-color: transparent;
            tap-highlight-color: transparent;
          }

          .qv-overlay {
            background: rgba(0, 0, 0, 0.85) !important;
          }

          .quick-view-trigger, .qv-close {
            -webkit-tap-highlight-color: transparent;
            -webkit-touch-callout: none;
          }
        }
      </style>
    `;

    document.body.insertAdjacentHTML('beforeend', modalHTML);
  }

  // ---------- Cart Helpers ----------
  function fetchCartJSON() {
    return fetch('/cart.js').then(function (response) {
      if (!response.ok) throw new Error('Cart fetch failed: ' + response.status);
      return response.json();
    });
  }

  function updateCartCountElements(count) {
    const cartBubbles = $$('.cart-count-bubble');
    cartBubbles.forEach(function (bubble) {
      const visibleSpan = bubble.querySelector('span:not(.visually-hidden)');
      const hiddenSpan = bubble.querySelector('.visually-hidden');

      if (visibleSpan) {
        if (count === 0) {
          visibleSpan.textContent = '0';
        } else if (count < 100) {
          visibleSpan.textContent = String(count);
        } else {
          visibleSpan.textContent = '99+';
        }
      }

      if (hiddenSpan) {
        hiddenSpan.textContent =
          count === 1 ? '1 item in cart' : count + ' items in cart';
      }

      bubble.style.display = 'inline';
    });
  }

  async function refreshCartDrawerSection() {
    const cartDrawer = $('cart-drawer');
    if (!cartDrawer) return;

    try {
      const response = await fetch('/?section_id=cart-drawer', {
        method: 'GET',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newCartDrawer = doc.querySelector('cart-drawer');
      if (!newCartDrawer) return;

      cartDrawer.innerHTML = newCartDrawer.innerHTML;
      cartDrawer.className = newCartDrawer.className;
    } catch (err) {
      console.error('Error refreshing cart drawer section:', err);
    }
  }

  function openCartDrawer() {
    const cartDrawer = $('cart-drawer');
    const drawerElement =
      $('#CartDrawer') || (cartDrawer && cartDrawer.querySelector('.cart-drawer'));
    const overlay =
      $('#CartDrawer-Overlay') ||
      (cartDrawer && cartDrawer.querySelector('.cart-drawer__overlay'));

    if (!cartDrawer) return;

    if (typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    } else {
      cartDrawer.classList.remove('is-empty');
      cartDrawer.classList.add('is-open', 'active');
      cartDrawer.style.visibility = 'visible';

      if (drawerElement) {
        drawerElement.style.transform = 'translateX(0)';
        drawerElement.style.visibility = 'visible';
      }

      if (overlay) {
        overlay.classList.add('is-visible');
        overlay.style.opacity = '1';
        overlay.style.visibility = 'visible';
      }

      document.body.classList.add('overflow-hidden', 'cart-drawer-open');
    }
  }

  async function addItemToCart(variantId, quantity) {
    const payload = { id: variantId, quantity: quantity };

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error('Add to cart failed: ' + response.status);
    }

    return response.json().catch(function () {
      return null;
    });
  }

  // ---------- Modal / Carousel / Product Logic ----------
  function setupModalEvents() {
    const modal = $('#quickViewModal');
    if (!modal) return;

    const overlay = $('.qv-overlay', modal);
    const closeBtn = $('.qv-close', modal);
    const minusBtn = $('.qv-minus', modal);
    const plusBtn = $('.qv-plus', modal);
    const qtyInput = $('.qv-qty-input', modal);
    const addToCartBtn = $('.qv-add-to-cart', modal);
    const buyWithPayBtn = $('.qv-buy-with-pay', modal);
    const moreOptionsBtn = $('.qv-more-options', modal);

    const titleEl = $('.qv-title', modal);
    const productTypeEl = $('.qv-product-type', modal);
    const priceEl = $('.qv-price', modal);

    const colorSection = $('.qv-section-color', modal);
    const colorsContainer = $('.qv-colors', modal);
    const sizeSection = $('.qv-section-size', modal);
    const sizesContainer = $('.qv-sizes', modal);

    function clearCarousel() {
      const carouselTrack = $('.qv-carousel-track', modal);
      const dotsContainer = $('.qv-carousel-dots', modal);
      if (carouselTrack) carouselTrack.innerHTML = '';
      if (dotsContainer) dotsContainer.innerHTML = '';
    }

    // ---- Mobile swipe support for FADE EFFECT ----
    const carouselContainer = $('.qv-carousel-container', modal);

    let touchStartX = 0;
    let touchEndX = 0;
    const swipeThreshold = 50;

    if (carouselContainer) {
      carouselContainer.addEventListener('touchstart', e => {
        if (carouselState.isLoadingImages) return;
        touchStartX = e.touches[0].clientX;
      }, { passive: true });

      carouselContainer.addEventListener('touchend', e => {
        if (carouselState.isLoadingImages) return;
        touchEndX = e.changedTouches[0].clientX;
        handleSwipe();
      }, { passive: true });
    }

    function handleSwipe() {
      const swipeDistance = touchEndX - touchStartX;
      
      if (Math.abs(swipeDistance) < swipeThreshold) return;
      
      if (swipeDistance > 0) {
        prevSlide();
      } else {
        nextSlide();
      }
      
      touchStartX = 0;
      touchEndX = 0;
    }

    function setLoadingState() {
      if (titleEl) titleEl.textContent = 'Loading...';
      if (productTypeEl) productTypeEl.textContent = '';
      if (priceEl) priceEl.textContent = '';

      if (colorSection && colorsContainer) {
        colorSection.style.display = 'none';
        colorsContainer.innerHTML = '';
      }
      if (sizeSection && sizesContainer) {
        sizeSection.style.display = 'none';
        sizesContainer.innerHTML = '';
      }

      if (qtyInput) qtyInput.value = '1';

      const carouselTrack = $('.qv-carousel-track', modal);
      const dotsContainer = $('.qv-carousel-dots', modal);
      if (carouselTrack) {
        carouselTrack.innerHTML = `
          <div class="qv-carousel-slide active" style="flex-direction:column;">
            <div class="qv-loading-spinner"></div>
            <div class="qv-loading-text">Loading Product</div>
          </div>
        `;
      }
      if (dotsContainer) dotsContainer.innerHTML = '';
    }

    function formatPrice(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, '${{amount}}');
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function closeModal() {
      if (!modal) return;
      modal.classList.remove('show');
      modal.classList.add('hide');
      setTimeout(function () {
        modal.style.display = 'none';
        modal.classList.remove('hide');
      }, 300);
      document.body.style.overflow = '';
    }

    // ----- Option meta builder -----
    function buildOptionMeta(product) {
      const meta = [];
      if (!product.options || !product.options.length) return meta;

      product.options.forEach(function (opt, index) {
        const name =
          typeof opt === 'string'
            ? opt
            : (opt && opt.name) || 'Option ' + (index + 1);
        let values =
          typeof opt === 'object' && opt && Array.isArray(opt.values)
            ? opt.values.slice()
            : [];

        if ((!values || !values.length) && Array.isArray(product.variants)) {
          product.variants.forEach(function (v) {
            if (v.options && v.options[index]) {
              const val = v.options[index];
              if (values.indexOf(val) === -1) values.push(val);
            }
          });
        }

        meta.push({ name: name, index: index, values: values });
      });

      return meta;
    }

    // ---- Image organization (DEDUPED + ORDERED) ----
    function organizeImages(product, colorMeta) {
      carouselState.colorImages = {};

      const allImages = product.media
        .filter(m => m.media_type === "image")
        .map(m => ({
          src: m.src,
          alt: (m.alt || "").toLowerCase()
        }));

      preloadImages(allImages.map(img => img.src));

      if (!colorMeta) {
        carouselState.colorImages._all = allImages.map(i => i.src);
        return;
      }

      colorMeta.values.forEach(colorValue => {
        const colorLower = colorValue.toLowerCase();
        const used = new Set();
        const ordered = [];

        (product.variants || []).forEach(variant => {
          if (
            variant.options &&
            variant.options[colorMeta.index] === colorValue &&
            variant.featured_image &&
            variant.featured_image.src
          ) {
            const src = variant.featured_image.src;
            if (!used.has(src)) {
              used.add(src);
              ordered.push(src);
            }
          }
        });

        allImages.forEach(img => {
          const file = img.src.split("/").pop().toLowerCase();

          const matchesColor =
            file.includes(`-${colorLower}`) ||
            file.includes(`${colorLower}-`) ||
            img.alt.includes(` ${colorLower}`) ||
            img.alt.endsWith(colorLower);

          if (matchesColor && !used.has(img.src)) {
            used.add(img.src);
            ordered.push(img.src);
          }
        });

        if (!ordered.length && allImages.length) {
          ordered.push(allImages[0].src);
        }

        carouselState.colorImages[colorValue] = ordered;
      });
    }

    function createColorOptions() {
    if (!colorsContainer || !colorSection) return;

    colorsContainer.innerHTML = '';

    const keys = Object.keys(carouselState.colorImages);

    if (keys.length === 0) {
        colorSection.style.display = 'none';
        return;
    }

    if (keys.length === 1 && keys[0] === '_all') {
        colorSection.style.display = 'none';
        return;
    }

    colorSection.style.display = '';

    const colorNames = keys.filter(k => k !== "_all");

    colorNames.forEach((colorName, index) => {
        const btn = document.createElement('button');
        btn.type = "button";
        btn.className = "qv-color-option";
        btn.dataset.colorName = colorName;
        btn.dataset.colorIndex = index;

        btn.style.cssText = `
        width:32px;
        height:32px;
        border:2px solid ${index === 0 ? '#000' : '#E5E5E5'};        
        cursor:pointer;
        overflow:hidden;
        position:relative;
        background:#FFF;
        padding:0;
        display:flex;
        align-items:center;
        justify-content:center;
        transition: border-color 0.2s ease;
        `;

        const fileName = colorName.toUpperCase() + ".png";
        const fileUrl = `/cdn/shop/files/${fileName}`;

        const swatch = document.createElement("div");
        swatch.style.cssText = `
        width:100%;
        height:100%;        
        background-size:cover;
        background-position:center;
        background-repeat:no-repeat;
        transition: opacity 0.2s ease;
        `;

        checkImageExists(fileUrl).then(found => {
        if (found) {
            swatch.style.backgroundImage = `url('${fileUrl}')`;
        } else {
            swatch.style.backgroundColor = colorName.toLowerCase();
        }
        });

        btn.appendChild(swatch);

        if (index === 0) btn.classList.add("active");

        btn.addEventListener("click", () => {
          if (btn.classList.contains('active') || carouselState.isLoadingImages) return;
          
          $$(".qv-color-option", colorsContainer).forEach(o => {
            o.classList.remove("active");
            o.style.borderColor = "#E5E5E5";
          });

          btn.classList.add("active");
          btn.style.borderColor = "#000";

          const chosenColor = btn.dataset.colorName;
          loadColorImages(chosenColor, 0);

          if (window.innerWidth <= 768) {
            const container = $('.qv-container', modal);
            const imageColumn = $('.qv-image-column', modal);

            if (container && imageColumn) {
              container.scrollTo({
                top: imageColumn.offsetTop,
                behavior: 'smooth'
              });
            }
          }
        });

        colorsContainer.appendChild(btn);
    });
    }

    function checkImageExists(url) {
    return new Promise(resolve => {
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = url;
    });
    }

    function createSizeOptions() {
      if (!sizeSection || !sizesContainer) return;

      sizesContainer.innerHTML = '';

      if (!productSizeMeta || !productSizeMeta.values.length) {
        sizeSection.style.display = 'none';
        return;
      }

      sizeSection.style.display = '';

      productSizeMeta.values.forEach(function (sizeName, index) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'qv-size-option';
        btn.textContent = sizeName;
        btn.dataset.sizeName = sizeName;

        btn.style.cssText = `
          min-width:48px;
          height:32px;
          padding:0 12px;
          border:1px solid ${index === 0 ? '#000' : '#E5E5E5'};
          background:${index === 0 ? '#000' : '#FFF'};
          color:${index === 0 ? '#FFF' : '#000'};
          font-size:13px;
          font-weight:500;
          letter-spacing:0.5px;          
          cursor:pointer;
          transition:all 0.15s;
        `;

        if (index === 0) btn.classList.add('active');

        btn.addEventListener('click', function () {
          $$('.qv-size-option', sizesContainer).forEach(function (other) {
            other.classList.remove('active');
            other.style.borderColor = '#E5E5E5';
            other.style.background = '#FFF';
            other.style.color = '#000';
          });

          btn.classList.add('active');
          btn.style.borderColor = '#000';
          btn.style.background = '#000';
          btn.style.color = '#FFF';
        });

        sizesContainer.appendChild(btn);
      });
    }

    function loadColorImages(colorKey, startIndex) {
      if (startIndex == null) startIndex = 0;
      if (carouselState.isLoadingImages) return;

      const images = carouselState.colorImages[colorKey];
      const carouselTrack = $('.qv-carousel-track', modal);
      const dotsContainer = $('.qv-carousel-dots', modal);

      if (!carouselTrack || !dotsContainer) return;

      if (!images || !images.length) {
        carouselTrack.innerHTML =
          '<div class="qv-carousel-slide active" style="display:flex;align-items:center;justify-content:center;flex-direction:column;color:#999;">' +
          '<div style="font-size:18px;margin-bottom:16px;">No images available</div>' +
          '</div>';
        dotsContainer.innerHTML = '';
        return;
      }

      carouselState.isLoadingImages = true;

      carouselTrack.innerHTML = '';

      images.forEach(function (imageSrc, index) {
        const slide = document.createElement('div');
        slide.className = 'qv-carousel-slide' + (index === startIndex ? ' active' : '');
        slide.dataset.index = String(index);

        const img = document.createElement('img');
        img.src = imageSrc;
        img.alt = `Image ${index + 1}`;
        img.decoding = 'async';
        img.loading = 'eager';
        img.style.cssText = 'max-width:100%;max-height:100%;object-fit:contain;';

        slide.appendChild(img);
        carouselTrack.appendChild(slide);
      });

      dotsContainer.innerHTML = '';
      images.forEach(function (_, index) {
        const dot = document.createElement('button');
        dot.className = 'qv-carousel-dot ' + (index === startIndex ? 'active' : '');
        dot.dataset.index = String(index);
        dot.addEventListener('click', function () {
          goToSlide(index);
        });
        dotsContainer.appendChild(dot);
      });

      carouselState.currentSlideIndex = startIndex;
      carouselState.totalSlides = images.length;
      carouselState.isLoadingImages = false;
    }

    function updateCarouselIndicators() {
      const dots = $$('.qv-carousel-dot', modal);
      dots.forEach(function (dot, index) {
        dot.classList.toggle('active', index === carouselState.currentSlideIndex);
      });
    }

    function updateCarouselPosition() {
      const slides = $$('.qv-carousel-slide', modal);
      slides.forEach(slide => {
        slide.classList.remove('active');
      });
      
      const currentSlide = $(`.qv-carousel-slide[data-index="${carouselState.currentSlideIndex}"]`, modal);
      if (currentSlide) {
        currentSlide.classList.add('active');
      }
      
      updateCarouselIndicators();
    }

    function goToSlide(index) {
      if (index < 0 || index >= carouselState.totalSlides || carouselState.isLoadingImages) return;
      
      carouselState.currentSlideIndex = index;
      updateCarouselPosition();
    }

    function nextSlide() {
      let next = carouselState.currentSlideIndex + 1;
      if (next >= carouselState.totalSlides) next = 0;
      goToSlide(next);
    }

    function prevSlide() {
      let prev = carouselState.currentSlideIndex - 1;
      if (prev < 0) prev = carouselState.totalSlides - 1;
      goToSlide(prev);
    }

    function getSelectedSizeValue() {
      if (!productSizeMeta) return null;
      const active = $('.qv-size-option.active', modal);
      return active ? active.dataset.sizeName : null;
    }

    function getSelectedColorValue() {
      if (!productColorMeta) return null;

      const active = $('.qv-color-option.active', modal);
      if (active && active.dataset.colorName) return active.dataset.colorName;

      return null;
    }

    function findMatchingVariant(product) {
      const sizeVal = getSelectedSizeValue();
      const colorVal = getSelectedColorValue();

      let match = null;

      (product.variants || []).some(function (variant) {
        let ok = true;

        if (productColorMeta && colorVal) {
          if (
            !variant.options ||
            variant.options[productColorMeta.index] !== colorVal
          ) {
            ok = false;
          }
        }

        if (ok && productSizeMeta && sizeVal) {
          if (
            !variant.options ||
            variant.options[productSizeMeta.index] !== sizeVal
          ) {
            ok = false;
          }
        }

        if (ok) {
          match = variant;
          return true;
        }
        return false;
      });

      if (!match && product.variants && product.variants.length) {
        match = product.variants[0];
      }

      return match;
    }

    // ---- Product Data -> UI ----
    function processProductData(product) {
      if (titleEl) titleEl.textContent = product.title || 'Product';

      if (productTypeEl) {
        const productTypeText = product.type || product.vendor || 'PRODUCT';
        productTypeEl.textContent = productTypeText || '';
      }

      if (priceEl) priceEl.textContent = formatPrice(product.price);

      carouselState.currentColorIndex = 0;
      carouselState.currentSlideIndex = 0;
      carouselState.totalSlides = 0;
      carouselState.colorImages = {};
      carouselState.isLoadingImages = false;

      productOptionMeta = buildOptionMeta(product);
      productColorMeta = null;
      productSizeMeta = null;

      productOptionMeta.forEach(function (meta) {
        const lower = meta.name.toLowerCase();
        if (!productColorMeta && (lower.indexOf('color') !== -1 || lower.indexOf('colour') !== -1)) {
          productColorMeta = meta;
        }
        if (!productSizeMeta && lower.indexOf('size') !== -1) {
          productSizeMeta = meta;
        }
      });

      organizeImages(product, productColorMeta);
      createColorOptions();
      createSizeOptions();

      const keys = Object.keys(carouselState.colorImages);
      if (keys.length) {
        const defaultKey = keys.includes('_all') ? '_all' : keys[0];
        loadColorImages(defaultKey, 0);
      } else {
        clearCarousel();
      }

      if (qtyInput) qtyInput.value = '1';
    }

    // ---- Global: openQuickView (instant open + loading state) ----
    window.openQuickView = function (productHandle) {
      if (!productHandle) return;

      modal.style.display = 'flex';
      modal.classList.add('show');
      document.body.style.overflow = 'hidden';

      setLoadingState();

      if (productCache[productHandle]) {
        currentQuickViewProduct = productCache[productHandle];
        processProductData(currentQuickViewProduct);
        return;
      }

      fetch('/products/' + productHandle + '.js')
        .then(function (response) {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.json();
        })
        .then(function (product) {
          productCache[productHandle] = product;
          currentQuickViewProduct = product;
          processProductData(product);
        })
        .catch(function (error) {
          console.error('Error loading product:', error);
          if (titleEl) titleEl.textContent = 'Product unavailable';
          if (productTypeEl) productTypeEl.textContent = '';
          if (priceEl) priceEl.textContent = '';
        });
    };

    // ---- Events ----
    if (overlay) overlay.addEventListener('click', closeModal);
    if (closeBtn) closeBtn.addEventListener('click', closeModal);

    const prevBtn = $('.qv-carousel-prev', modal);
    const nextBtn = $('.qv-carousel-next', modal);
    if (prevBtn) prevBtn.addEventListener('click', prevSlide);
    if (nextBtn) nextBtn.addEventListener('click', nextSlide);

    if (minusBtn && qtyInput) {
      minusBtn.addEventListener('click', function () {
        const value = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = Math.max(1, value - 1);
      });
    }

    if (plusBtn && qtyInput) {
      plusBtn.addEventListener('click', function () {
        const value = parseInt(qtyInput.value, 10) || 0;
        qtyInput.value = value + 1;
      });
    }

    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', async function () {
        const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        const originalDisabled = addToCartBtn.disabled;
        const originalHTML = addToCartBtn.innerHTML;

        addToCartBtn.disabled = true;
        addToCartBtn.innerHTML =
          '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" style="animation:spin 1s linear infinite;">' +
          '<circle cx="10" cy="10" r="8" stroke="white" stroke-width="2" stroke-dasharray="30 10" stroke-linecap="round"></circle>' +
          '</svg>' +
          ' ADDING...';

        try {
          const product = currentQuickViewProduct;
          if (!product || !product.variants || !product.variants.length) {
            throw new Error('Product data not available');
          }

          const variant = findMatchingVariant(product);
          if (!variant || !variant.id) {
            throw new Error('No variant found');
          }

          await addItemToCart(variant.id, quantity);

          const cart = await fetchCartJSON();
          updateCartCountElements(cart.item_count);

          await refreshCartDrawerSection();
          openCartDrawer();

          closeModal();
          showNotification('Added ' + product.title + ' to cart!', 'success');
        } catch (err) {
          console.error('Add to cart error:', err);
          showNotification('Failed to add to cart. Please try again.', 'error');
        } finally {
          addToCartBtn.innerHTML = originalHTML;
          addToCartBtn.disabled = originalDisabled;
        }
      });
    }

    if (buyWithPayBtn) {
      buyWithPayBtn.addEventListener('click', function () {
        window.location.href = '/checkout';
      });
    }

    if (moreOptionsBtn) {
      moreOptionsBtn.addEventListener('click', function () {
        showNotification('More payment options would be shown here', 'info');
      });
    }

    document.addEventListener('keydown', function (e) {
      if (modal.style.display === 'flex') {
        if (e.key === 'Escape') {
          closeModal();
        } else if (e.key === 'ArrowLeft') {
          prevSlide();
        } else if (e.key === 'ArrowRight') {
          nextSlide();
        }
      }
    });

    function showNotification(message, type) {
      if (!type) type = 'info';
      const bg =
        type === 'success'
          ? '#000'
          : type === 'error'
          ? '#FF3B30'
          : '#007AFF';

      const notification = document.createElement('div');
      notification.style.cssText =
        'position:fixed;top:24px;right:24px;padding:16px 24px;background:' +
        bg +
        ';color:white;border-radius:12px;font-weight:600;z-index:10001;box-shadow:0 8px 24px rgba(0,0,0,0.2);animation:slideIn 0.3s ease-out;';
      notification.textContent = message;
      document.body.appendChild(notification);

      setTimeout(function () {
        notification.style.animation = 'slideOut 0.3s ease-out';
        setTimeout(function () {
          notification.remove();
        }, 300);
      }, 3000);
    }
  }

  // ---------- Triggers ----------
  function setupTriggers() {
    document.addEventListener('click', function (e) {
      let trigger = e.target.closest('[data-quick-view]');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        const handle = trigger.getAttribute('data-quick-view');
        if (window.openQuickView && handle) window.openQuickView(handle);
        return;
      }

      trigger = e.target.closest('.quick-view-trigger');
      if (trigger && trigger.dataset.productHandle) {
        e.preventDefault();
        e.stopPropagation();
        const handle2 = trigger.dataset.productHandle;
        if (window.openQuickView && handle2) window.openQuickView(handle2);
        return;
      }
    });

    setTimeout(function () {
      const triggers = $$(
        '[data-quick-view], .quick-view-trigger[data-product-handle]'
      );
      triggers.forEach(function (trigger) {
        if (!trigger.hasAttribute('data-qv-bound')) {
          trigger.setAttribute('data-qv-bound', 'true');
          trigger.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const handle =
              this.dataset.productHandle ||
              this.getAttribute('data-quick-view');
            if (handle && window.openQuickView) {
              window.openQuickView(handle);
            }
          });
        }
      });
    }, 100);
  }

  // ---------- Init ----------
  setupModalEvents();
  setupTriggers();
});